import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  icon: "description",
  quotes: [],
  quote: {},
  quoteStatuses: [
    { id: 1, name: "Issued", colour: "warning", list: "Live Quotes" },
    { id: 2, name: "Cook Verified", colour: "warning", list: "Live Quotes" },
    { id: 3, name: "Client Accepted", colour: "warning", list: "Live Quotes" },
    { id: 4, name: "Order Placed", colour: "warning", list: "Live Quotes" },
    {
      id: 5,
      name: "Work Completed",
      colour: "success",
      list: "Completed Quotes"
    },
    { id: 6, name: "Cook Rejected", colour: "danger", list: "Rejected Quotes" },
    {
      id: 7,
      name: "Client Rejected",
      colour: "danger",
      list: "Rejected Quotes"
    }
  ],
  quoteTypes: [{ id: 1, name: "General" }, { id: 2, name: "Stat. Insp. Item" }],
  quotePriorities: [
    { id: 0, name: "Not Set" },
    { id: 1, name: "High" },
    { id: 2, name: "Medium" },
    { id: 3, name: "Low" }
  ]
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
